// Plausible Analytics integration using bundled npm package.
// Reads the Plausible site key from a meta tag rendered by
// PlausibleHelper#plausible_meta_tag (resolved per surface from the
// controller's plausible_site — marketing vs. app site key).
// Manual pageview tracking on turbo:load for Turbo Drive support.
// Privacy: prefers server-rendered route patterns (plausible-path meta)
// for authenticated pages so customer IDs never leave the browser.

import { init, track } from '@plausible-analytics/tracker'
import appsignal from '../application/appsignal'

// init/track throws on second call, missing/invalid domain, or
// track-before-init. Route to AppSignal so analytics outages have
// a signal — no global window.onerror handler will catch this.
const reportPlausibleError = (error, action) =>
  appsignal.sendError(error, (span) => {
    span.setAction(action)
    span.setTags({ source: 'plausible_lib' })
  })

const domainMeta = document.querySelector('meta[name="plausible-domain"]')
if (domainMeta) {
  try {
    init({
      domain: domainMeta.content,
      endpoint: '/pa/event',
      autoCapturePageviews: false,
    })
  } catch (error) {
    reportPlausibleError(error, 'plausible.init')
  }

  document.addEventListener('turbo:load', () => {
    const pathMeta = document.querySelector('meta[name="plausible-path"]')
    const trackingPath = pathMeta?.content || window.location.pathname

    try {
      track('pageview', { u: window.location.origin + trackingPath })
    } catch (error) {
      reportPlausibleError(error, 'plausible.pageview')
    }
  })
}
